import { render } from "./JumpLinkUnlock.vue?vue&type=template&id=707d8bcc&scoped=true"
import script from "./JumpLinkUnlock.vue?vue&type=script&lang=js"
export * from "./JumpLinkUnlock.vue?vue&type=script&lang=js"

import "./JumpLinkUnlock.vue?vue&type=style&index=0&id=707d8bcc&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707d8bcc"]])

export default __exports__